<!--
 * @Author: xuchen
 * @Date: 2020-03-10 14:30:33
 * @Desc: 检索框
 -->
<template>
  <div class="search-bar-container">
    <div class="search-bar-content flex items-center justify-center">
      <el-input
        v-model="enterpriseName"
        class="search-input"
        placeholder="搜索企业名称"
        clearable
        :clear-icon-click="handleClear"
        @keyup.enter.native="handleSearchKeyword"
      />
      <separate :is-vertical="false" />
      <el-button type="primary" @click="handleSearchKeyword">查询</el-button>
      <separate :is-vertical="false" />
      <el-popover ref="popoverRef" v-model="showPopover" placement="bottom-end" width="787">
        <el-button slot="reference" type="link">条件检索</el-button>
        <filter-tags
          ref="filterTags"
          :region-data="regionData"
          :data-provider="tags"
          :default-selected-keys="selectedKeys"
          :default-selected-region="selectedRegion"
          @submit="handleSubmitFilter"
          @reset="handleResetFilter"
        />
      </el-popover>
    </div>
  </div>
</template>

<script>
import Separate from '@/components/Separate/Separate'
import FilterTags from '@/components/EnterpriseVideoInspection/FilterTags'

export default {
  name: 'SearchBar',
  components: {
    Separate,
    FilterTags
  },
  props: {
    tags: {
      type: Array,
      required: true
    },
    regionData: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      enterpriseName: '', // 检索关键字
      showPopover: false, // 显示条件筛选
      selectedKeys: [], // 选中的标签主键
      selectedRegion: [], // 选中的区域
      unresolveKeys: {}, // 未处理的选中具体标签信息
      allTags: [
        {
          labelType: '区域',
          list: [
            { labelId: '1', labelName: '建德市' },
            { labelId: '2', labelName: '万年县' }
          ]
        }
      ] // 所有标签
    }
  },
  watch: {
    /**
     * @author xuchen
     * @date 2020-03-10 15:47:52
     * @desc 重置条件筛选选中项
     */
    showPopover(val) {
      // 隐藏条件筛选，重置选择项
      if (val) {
        this.$refs['filterTags'].changeMoreBtnDisplay()
      }
    }
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-10 15:01:36
     * @desc 清空
     */
    handleClear(e) {},
    /**
     * @author xuchen
     * @date 2020-03-10 15:01:43
     * @desc 检索
     */
    handleSearchKeyword() {
      // 未输入企业名称
      if (!this.enterpriseName) {
        this.$message.warning('请输入企业名称查询')
        return
      }
      this.$refs['filterTags'].submitFilter()
    },

    /**
     * @author xuchen
     * @date 2020-03-10 15:22:39
     * @desc 检索标签
     */
    handleSubmitFilter({ keys, unresolveKeys, regionCodeList }) {
      this.selectedKeys = keys
      this.selectedRegion = regionCodeList
      this.unresolveKeys = unresolveKeys
      const { enterpriseName } = this
      const payload = {
        enterpriseName,
        ...unresolveKeys,
        regionCodeList
      }
      this.$emit('searchList', payload)
      this.showPopover = false
    },

    /**
     * @author xuchen
     * @date 2020-03-10 15:22:54
     * @desc 重置标签
     */
    handleResetFilter() {
      this.selectedKeys = []
      this.selectedRegion = []
    }
  }
}
</script>

<style lang="scss" scoped>
.search-bar-container {
  .search-bar-content {
    margin: 0 auto;
    .search-input {
      width: 616px;
    }
  }
}
</style>
